import type {ConfigurationSelection, ConfiguratorBundleResponseBody} from '@dms/api/new-vehicle';

type SelectionCatalogueTree = {
  makes: {
    id: string;
    name: string;
    models: {
      id: string;
      name: string;
      modelYears: {id: string; name: string}[];
    }[];
  }[];
};

export const getSelectionContext = (
  tree: SelectionCatalogueTree | undefined,
  bundle: ConfiguratorBundleResponseBody | undefined,
  selection: Pick<
    ConfigurationSelection,
    'modelYearId' | 'trimId' | 'variantId' | 'colourId' | 'upholsteryId'
  >
) => {
  const make = tree?.makes.find((candidateMake) =>
    candidateMake.models.some((candidateModel) =>
      candidateModel.modelYears.some((modelYear) => modelYear.id === selection.modelYearId)
    )
  );
  const model = make?.models.find((candidateModel) =>
    candidateModel.modelYears.some((modelYear) => modelYear.id === selection.modelYearId)
  );
  const modelYear = model?.modelYears.find(({id}) => id === selection.modelYearId);
  const trim = bundle?.trims.find(({id}) => id === selection.trimId);
  const variant = bundle?.variants.find(({id}) => id === selection.variantId);
  const engine = bundle?.engines.find(({id}) => id === variant?.engineId);
  const colour = bundle?.colours.find(({id}) => id === selection.colourId);
  const upholstery = bundle?.upholsteries.find(({id}) => id === selection.upholsteryId);

  return {make, model, modelYear, trim, variant, engine, colour, upholstery};
};
